import { MetagraphIndexerBaseUrl } from '@/common/consts/api.ts';
import { createResourcesProvider } from '@/common/utils/resources_provider.tsx';

const [NetworkStatsProvider, useNetworkStatsProvider] = createResourcesProvider(
  'NetworkStatsProvider',
  {
    stats: {
      apiUrl: `${MetagraphIndexerBaseUrl}/network/stats`,
      initialState: null,
      queryParams: {},
      resource: {} as {
        activeSensorCount: number;
        validatorNodesL0: number;
        validatorNodesL1: number;
        totalSnapshots: number;
        feesPaid: number;
        totalDagLocked: number;
        totalDorLocked: number;
        totalDorInCirculation: number;
        totalBountiesAwarded: number;
      },
      pathParams: {}
    }
  }
);

export { NetworkStatsProvider, useNetworkStatsProvider };
